var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"filterable":"","selected":_vm.selectedId,"data":_vm.lists,"clearable":"","placeholder":"请选择"},on:{"update:selected":function($event){_vm.selectedId=$event},"updateSelect":function($event){return _vm.fnUpdateSelect()}}})}
var staticRenderFns = []

export { render, staticRenderFns }